import React, { useEffect } from "react";
import { useParams } from 'react-router-dom';
import { useSpinnerContext, useSessionContext } from '@contexts';
import { sunboundPayProxy } from '@proxies';
import SetupLogin from "./setup-login";
import SetupCredentials from "./setup-credentials";
import { useLocation, useNavigate } from 'react-router-dom';
import { helpers, Constants } from "@shared";
import { useAllowedPaymentTypes } from "../hooks/useAllowedPaymentTypes/useAllowedPaymentTypes";

const Signup = () => {

    const location = useLocation(), navigate = useNavigate();
    const { setSpinnerShow } = useSpinnerContext();
    const params = useParams();
    const { sessionId } = params;
    const {
        session,
        setSession,
        accounts,
        rawSession,
        setShowAccountSelector
    } = useSessionContext();
    const { allowedPaymentTypes, isError: allowedPaymentTypesIsError } = useAllowedPaymentTypes();

    useEffect(() => {
        (async () => {
            let hasError = false;
            setSpinnerShow(true);
            try {
                const response = await sunboundPayProxy.getSession(sessionId);
                setSession(response);
                setShowAccountSelector(false);
            } catch (error) {
                console.error(error);
                hasError = true;
            }
            setSpinnerShow(false);
            if (hasError)
                helpers.navigateStart(location, navigate, Constants.Flows.resendWelcome.id, undefined, undefined, params);
        })();
    }, []);

    const next = () => {

        if (accounts.length > 1) {

            let sessionAccounts;
            {
                const { accounts, ...rest } = rawSession;
                sessionAccounts = accounts.map(account => ({ ...account, ...rest }));
            }

            const [account, ...rest] = sessionAccounts;
            const { hasPaymentMethods } = account;

            console.log(hasPaymentMethods, rest.length !== 0);
            helpers.navigateStart(location, navigate, Constants.Flows.setupMultiple.id, {
                missingAccounts: rest.length !== 0,
                hasPaymentMethods
            }, {
                account,
                accounts,
                setupAccounts: [...rest],
                hasMultipleAccounts: true
            }, params);
        } else {
            const {
                paymentPreferences: { hasDefaultPaymentMethod, defaultPaymentMethod },
                accountPreferences: { isAutoPay },
                hasPaymentMethods
            } = session;

            const defaultPaymentValid = (allowedPaymentTypes.includes(defaultPaymentMethod?.idPaymentType) || allowedPaymentTypesIsError);

            helpers.navigateStart(location, navigate, Constants.Flows.setupSingle.id, {
                hasDefaultPaymentMethod: hasDefaultPaymentMethod && defaultPaymentValid,
                hasPaymentMethods,
                isAutoPay
            }, {
                defaultPaymentMethod,
                account: { ...session },
                hasMultipleAccounts: false
            }, params);
        }
    };

    let renderComponent = null;
    if (session) {
        const { email } = session;
        renderComponent = session.hasPassword ?
            <SetupLogin initial={{ email }} success={next} /> : <SetupCredentials initial={{ email }} success={next} />;
    }

    return (
        <div className="page-content-wrapper">
            {renderComponent}
        </div>
    );

};

export default Signup;